import type { AuthorizedParcel, Parcel } from '@dpdgroupuk/fmx-ui/types/Parcel';

export const getImagesData = (parcel: Parcel & AuthorizedParcel) =>
  parcel.consumer && parcel.consumer.image;
